import { Pipe, PipeTransform } from '@angular/core';

import { anexoTipoPDF, anexoTipoTXT, anexoTipoZIP, anexoTipoDOC, anexoTipoPPT, anexoTipoXLS, anexoTipoImagem, anexoTipoAudio, anexoTipoVideo, anexoTipoXML, anexoTipoOutro } from '../../../models';

/**
 * Pipe para retornar o icon apropriado conforme o tipo de anexo
 */
@Pipe({
    name: 'anexoTipoIcon'
})
export class AnexoTipoIconPipe implements PipeTransform {

    transform(value: number) {
        if (value == null) {
            return '';
        }

        switch (value) {
            case anexoTipoPDF.id:
                return 'far fa-file-pdf';
            case anexoTipoTXT.id:
                return 'far fa-file-alt';
            case anexoTipoZIP.id:
                return 'fa fa-file-archive-o';
            case anexoTipoDOC.id:
                return 'fa fa-file-word-o';
            case anexoTipoPPT.id:
                return 'fa fa-file-powerpoint-o';
            case anexoTipoXLS.id:
                return 'fa fa-file-excel-o';
            case anexoTipoImagem.id:
                return 'fa fa-file-image-o';
            case anexoTipoAudio.id:
                return 'fa fa-file-audio-o';
            case anexoTipoVideo.id:
                return 'fa fa-file-video-o';
            case anexoTipoXML.id:
                return 'fa fa-file-code-o';
            case anexoTipoOutro.id:
                return 'fa fa-file-o';
            default:
                return 'fa fa-file-o';
        }
    }
}
